import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ScrollableContent from '../../ScrollableContent';
import { ThemeOptions } from '../../publicSession/types';
import DialogPopupLayout from './DialogPopupLayout';
import LoadingIndicator from '../../LoadingIndicator';
import s from './DialogPopup.scss';
var DialogPopup = /** @class */ (function (_super) {
    __extends(DialogPopup, _super);
    function DialogPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            scrolledTop: true,
            scrolledBottom: false,
        };
        _this.onContentScroll = function (scrollTop, distanceToBottom) {
            var scrolledTop = scrollTop === 0;
            var scrolledBottom = distanceToBottom === 0;
            var state = _this.state;
            if (scrolledTop !== state.scrolledTop ||
                scrolledBottom !== state.scrolledBottom) {
                _this.setState({
                    scrolledTop: scrolledTop,
                    scrolledBottom: scrolledBottom,
                });
            }
        };
        return _this;
    }
    DialogPopup.prototype.render = function () {
        var _a = this.props, headerClassName = _a.headerClassName, isLoading = _a.isLoading, headerStickyClassName = _a.headerStickyClassName, contentClassName = _a.contentClassName, withContentPaddings = _a.withContentPaddings, layoutContentClassName = _a.layoutContentClassName, contentWrapperClassName = _a.contentWrapperClassName, children = _a.children, onClose = _a.onClose, hasBackToTop = _a.hasBackToTop, props = __rest(_a, ["headerClassName", "isLoading", "headerStickyClassName", "contentClassName", "withContentPaddings", "layoutContentClassName", "contentWrapperClassName", "children", "onClose", "hasBackToTop"]);
        var isHeaderSticky = !this.state.scrolledTop;
        return (React.createElement(DialogPopupLayout, __assign({}, props, { headerClassName: classnames(headerClassName, isHeaderSticky && s['header-sticky'], isHeaderSticky && headerStickyClassName), contentClassName: layoutContentClassName, onClose: onClose }),
            isLoading && (React.createElement(LoadingIndicator, { className: s['loader'], view: "daSymbol", coverMode: true, withOverlay: true })),
            React.createElement(ScrollableContent, { className: classnames(s['content'], !withContentPaddings && s['no-content-paddings'], contentClassName), wrapperClassName: contentWrapperClassName, onScrolled: this.onContentScroll, hasBackToTop: hasBackToTop, backToTopClassName: s['back-to-top'], backToTopForcedTheme: ThemeOptions.LIGHT }, children)));
    };
    DialogPopup.defaultProps = { withContentPaddings: true };
    return DialogPopup;
}(React.Component));
export { DialogPopup };
export default DialogPopup;
//# sourceMappingURL=DialogPopup.js.map